import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      display: flex;\n      ", " {\n        flex-direction: row;\n        align-items: baseline;\n        margin-right: 16px;\n        margin-bottom: 0;\n      }\n\n      ", " {\n        margin-right: 8px;\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        flex-direction: row;\n        justify-content: flex-end;\n        align-items: baseline;\n      }\n      ", " {\n        flex-grow: 0;\n        text-align: right;\n        overflow: hidden;\n        margin-right: 8px;\n        white-space: normal;\n      }\n\n      ", " {\n        flex-grow: 1;\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  min-height: ", ";\n  font-size: ", ";\n  color: ", ";\n  visibility: ", ";\n  margin-top: 4px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  align-items: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      &::before {\n        content: '* ';\n        color: ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: inline-block;\n  padding-bottom: 4px;\n  font-size: ", ";\n  color: ", ";\n  white-space: nowrap;\n  line-height: 1.5;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  margin-bottom: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { layout, flexbox } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';
var Content = styled.div(_templateObject(), flexbox);
var LabelWrap = styled.div(_templateObject2(), layout, themeGet('form.label.fontSize'), themeGet('form.label.color'), function (props) {
  return props.required && css(_templateObject3(), themeGet('form.label.requiredColor'));
});
var InputWrap = styled.div(_templateObject4());
var InputIconWrap = styled.div(_templateObject5());
var IconWrapper = styled.span(_templateObject6());
var ErrorMessage = styled.div(_templateObject7(), themeGet('form.errorMessage.minHeight'), themeGet('form.errorMessage.fontSize'), themeGet('form.errorMessage.color'), function (props) {
  return props.visible ? 'visible' : 'hidden';
});
var statusColorMapping = {
  success: 'success',
  error: 'danger'
};
export var FormItem = function FormItem(_ref) {
  var label = _ref.label,
      meta = _ref.meta,
      input = _ref.input,
      children = _ref.children,
      required = _ref.required,
      labelWidth = _ref.labelWidth,
      validateStatus = _ref.validateStatus,
      rest = _objectWithoutProperties(_ref, ["label", "meta", "input", "children", "required", "labelWidth", "validateStatus"]);

  return (
    /*#__PURE__*/
    React.createElement(Content, rest,
    /*#__PURE__*/
    React.createElement(LabelWrap, {
      required: required,
      width: labelWidth
    },
    /*#__PURE__*/
    React.createElement("label", {
      htmlFor: input.name
    }, label)),
    /*#__PURE__*/
    React.createElement(InputWrap, null,
    /*#__PURE__*/
    React.createElement(InputIconWrap, null,
    /*#__PURE__*/
    React.cloneElement(children, {
      id: input.name,
      error: meta.touched && (meta.error || meta.submitError)
    }), validateStatus &&
    /*#__PURE__*/
    React.createElement(IconWrapper, null,
    /*#__PURE__*/
    React.createElement(Icon, {
      name: validateStatus && validateStatus.toUpperCase(),
      color: statusColorMapping[validateStatus],
      fontSize: 20
    }))),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      visible: meta.touched
    }, meta.error || meta.submitError)))
  );
};
FormItem.defaultProps = {
  meta: {},
  input: {},
  flexDirection: 'column'
};
var VERTICAL = 'vertical';
var HORIZONTAL = 'horizontal';
var INLINE = 'inline';
export var Form = styled.form(_templateObject8(), layout, function (props) {
  return props.layout === HORIZONTAL && css(_templateObject9(), Content, LabelWrap, InputWrap);
}, function (props) {
  return props.layout === INLINE && css(_templateObject10(), Content, LabelWrap);
});
Form.defaultProps = {
  layout: VERTICAL
};